import { render } from "./AttendanceEventModal.vue?vue&type=template&id=6e4fbf3e&scoped=true"
import script from "./AttendanceEventModal.vue?vue&type=script&lang=js"
export * from "./AttendanceEventModal.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4fbf3e"]])

export default __exports__